import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RevenueState {
  filters: {
    sale: {
      monthly: {
        isViewProductId: boolean;
        isViewCompanyName: boolean;
        isViewArtistName: boolean;
        isViewTitleName: boolean;
        isViewVariationName: boolean;
        isViewVariationProductCode: boolean;
        isViewDownloadDate: boolean;
        isViewVariationJanCode: boolean;
        isViewTitleLabel: boolean;
      };
      daily: {
        isViewProductId: boolean;
        isViewCompanyName: boolean;
        isViewArtistName: boolean;
        isViewTitleName: boolean;
        isViewVariationName: boolean;
        isViewVariationProductCode: boolean;
        isViewDownloadDate: boolean;
        isViewVariationJanCode: boolean;
        isViewTitleLabel: boolean;
      };
      detail: {
        isViewProductId: boolean;
        isViewCompanyName: boolean;
        isViewArtistName: boolean;
        isViewTitleName: boolean;
        isViewVariationName: boolean;
        isViewVariationProductCode: boolean;
        isViewDownloadDate: boolean;
        isViewVariationJanCode: boolean;
        isViewTitleLabel: boolean;
      };
    };
    cost: {
      monthly: {
        isViewProductId: boolean;
        isViewCompanyName: boolean;
        isViewArtistName: boolean;
        isViewTitleName: boolean;
        isViewVariationName: boolean;
        isViewVariationProductCode: boolean;
        isViewDownloadDate: boolean;
      };
      daily: {
        isViewProductId: boolean;
        isViewCompanyName: boolean;
        isViewArtistName: boolean;
        isViewTitleName: boolean;
        isViewVariationName: boolean;
        isViewVariationProductCode: boolean;
        isViewDownloadDate: boolean;
      };
      detail: {
        isViewProductId: boolean;
        isViewCompanyName: boolean;
        isViewArtistName: boolean;
        isViewTitleName: boolean;
        isViewVariationName: boolean;
        isViewVariationProductCode: boolean;
        isViewDownloadDate: boolean;
      };
    };
  };
}

export const initialRevenueState: RevenueState = {
  filters: {
    sale: {
      monthly: {
        isViewProductId: true,
        isViewCompanyName: true,
        isViewArtistName: true,
        isViewTitleName: true,
        isViewVariationName: true,
        isViewVariationProductCode: true,
        isViewDownloadDate: true,
        isViewVariationJanCode: true,
        isViewTitleLabel: true,
      },
      daily: {
        isViewProductId: true,
        isViewCompanyName: true,
        isViewArtistName: true,
        isViewTitleName: true,
        isViewVariationName: true,
        isViewVariationProductCode: true,
        isViewDownloadDate: true,
        isViewTitleLabel: true,
        isViewVariationJanCode: true,
      },
      detail: {
        isViewProductId: true,
        isViewCompanyName: true,
        isViewArtistName: true,
        isViewTitleName: true,
        isViewVariationName: true,
        isViewVariationProductCode: true,
        isViewDownloadDate: true,
        isViewTitleLabel: true,
        isViewVariationJanCode: true,
      },
    },
    cost: {
      monthly: {
        isViewProductId: true,
        isViewCompanyName: true,
        isViewArtistName: true,
        isViewTitleName: true,
        isViewVariationName: true,
        isViewVariationProductCode: true,
        isViewDownloadDate: true,
      },
      daily: {
        isViewProductId: true,
        isViewCompanyName: true,
        isViewArtistName: true,
        isViewTitleName: true,
        isViewVariationName: true,
        isViewVariationProductCode: true,
        isViewDownloadDate: true,
      },
      detail: {
        isViewProductId: true,
        isViewCompanyName: true,
        isViewArtistName: true,
        isViewTitleName: true,
        isViewVariationName: true,
        isViewVariationProductCode: true,
        isViewDownloadDate: true,
      },
    },
  },
};

export const RevenueSlice = createSlice({
  name: 'revenue',
  initialState: initialRevenueState,
  reducers: {
    setSaleMonthlyFilters: (state, data: PayloadAction<{ filters: any }>) => {
      const { payload } = data;
      return {
        ...state,
        filters: { ...state.filters, sale: { ...state.filters.sale, monthly: payload.filters } },
      };
    },
    setCostMonthlyFilters: (state, data: PayloadAction<{ filters: any }>) => {
      const { payload } = data;
      return {
        ...state,
        filters: { ...state.filters, cost: { ...state.filters.cost, monthly: payload.filters } },
      };
    },
    setSaleDailyFilters: (state, data: PayloadAction<{ filters: any }>) => {
      const { payload } = data;
      return {
        ...state,
        filters: { ...state.filters, sale: { ...state.filters.sale, daily: payload.filters } },
      };
    },
    setCostDailyFilters: (state, data: PayloadAction<{ filters: any }>) => {
      const { payload } = data;
      return {
        ...state,
        filters: { ...state.filters, cost: { ...state.filters.cost, daily: payload.filters } },
      };
    },
    setSaleDetailFilters: (state, data: PayloadAction<{ filters: any }>) => {
      const { payload } = data;
      return {
        ...state,
        filters: { ...state.filters, sale: { ...state.filters.sale, detail: payload.filters } },
      };
    },
    setCostDetailFilters: (state, data: PayloadAction<{ filters: any }>) => {
      const { payload } = data;
      return {
        ...state,
        filters: { ...state.filters, cost: { ...state.filters.cost, detail: payload.filters } },
      };
    },
    resetRevenueFilters: (state) => {
      state = { ...initialRevenueState };
      return state;
    },
  },
});

export const {
  setSaleMonthlyFilters,
  setCostMonthlyFilters,
  setSaleDailyFilters,
  setCostDailyFilters,
  setSaleDetailFilters,
  setCostDetailFilters,
  resetRevenueFilters,
} = RevenueSlice.actions;

export default RevenueSlice.reducer;
